import "./SignIn.css";
import React, {useEffect, useCallback} from "react";
import useAuthToken from "../../hooks/useAuthToken";
import {Link, useHistory} from "react-router-dom";
import Loading from "../../components/modules/Loading";

export default function SignOut() {
  /*
  Responsible for ensuring global state has valid records for
  - auth_token
  - logged in user base data
   */

  const history = useHistory();
  const {clearToken} = useAuthToken();

  const goSignIn = useCallback(() => {
    // requires a hard reload of page to flush out Redux state
    window.location.replace('/signin')
    // history.push({
    //   pathname: "/signin",
    // });
  }, [history]);

  useEffect(() => {
    clearToken()
    goSignIn()
  }, [clearToken, goSignIn]);

  return (<Loading/>)
}
